module.exports = __webpack_public_path__ + "img/mary's nutritionals.93da7588.png";